import React from 'react';
import { useTokenExpiration } from '../../hooks/useTokenExpiration';
import { useAuth } from '../../contexts/AuthContext';
import './TokenExpirationWarning.css';

export const TokenExpirationWarning: React.FC = () => {
  const { shouldRefresh, timeUntilExpiration, isExpired } = useTokenExpiration();
  const { logout } = useAuth();

  if (isExpired) {
    return null; // AuthContext sẽ tự động logout
  }

  if (!shouldRefresh) {
    return null;
  }

  const minutes = Math.floor(timeUntilExpiration / 60000);
  const seconds = Math.floor((timeUntilExpiration % 60000) / 1000);

  const handleExtendSession = () => {
    // Implement refresh token logic here
    console.log('Extending session...');
  };

  const handleLogout = () => {
    logout();
  };

  return (
    <div className="token-warning-overlay">
      <div className="token-warning-modal">
        <div className="warning-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" fill="#ff9800"/>
          </svg>
        </div>
        
        <h3>Phiên làm việc sắp hết hạn</h3>
        <p>
          Phiên làm việc của bạn sẽ hết hạn sau <strong>{minutes}:{seconds.toString().padStart(2, '0')}</strong>
        </p>
        
        <div className="warning-actions">
          <button className="btn-extend" onClick={handleExtendSession}>
            Gia hạn phiên
          </button>
          <button className="btn-logout" onClick={handleLogout}>
            Đăng xuất
          </button>
        </div>
      </div>
    </div>
  );
};
